export default {"src":"/_next/static/media/patient neuro.2d4571ef.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};